const fetchSeatData = async (date, subtripId) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_MODULE_DOMAIN}/tickets/seat/${subtripId}/${date}`
    );

    if (!response.ok) {
      throw new Error(`Seat request failed with status ${response.status}`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error fetching seat data:", error);
    throw error;
  }
};

export default fetchSeatData;